import { render, staticRenderFns } from "./seeClassCurriculumParameter.vue?vue&type=template&id=46808627"
import script from "./seeClassCurriculumParameter.vue?vue&type=script&lang=js"
export * from "./seeClassCurriculumParameter.vue?vue&type=script&lang=js"
import style0 from "./seeClassCurriculumParameter.vue?vue&type=style&index=0&id=46808627&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports